import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combine les classes CSS avec gestion des conflits Tailwind
 * Utilise clsx pour la logique conditionnelle + tailwind-merge pour dédupliquer
 */
export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

/**
 * Formater un nombre avec des séparateurs de milliers
 */
export function formatNumber(num: number, locale: string = 'fr-FR'): string {
    return new Intl.NumberFormat(locale).format(num);
}

/**
 * Générer un lien WhatsApp
 */
export function getWhatsAppLink(phone: string, message?: string): string {
    const cleanPhone = phone.replace(/\D/g, '');
    const encodedMessage = message ? `?text=${encodeURIComponent(message)}` : '';
    return `https://wa.me/${cleanPhone}${encodedMessage}`;
}

/**
 * Obtenir le chemin localisé
 */
export function getLocalizedPath(locale: string, path: string): string {
    return `/${locale}${path}`;
}

/**
 * Vérifier si une locale est supportée
 */
export const SUPPORTED_LOCALES = ['fr', 'en', 'ht'] as const;
export type SupportedLocale = typeof SUPPORTED_LOCALES[number];

export function isValidLocale(locale: string): locale is SupportedLocale {
    return SUPPORTED_LOCALES.includes(locale as SupportedLocale);
}
